<template>
  <div v-if="checkedResponses.length" class="fixed-block-wrap">
    <div class="fixed-block-wrap--container">
      <loader-wrapper :loading="!loaded">
        <span><b>Погрузка:</b> {{ thousandths(params.netto_ttn, 0) }}</span>
        <span><b>Выгрузка:</b> {{ thousandths(params.netto_fact, 0) }}</span>
        <span><b>Сумма:</b> {{ thousandths(params.amount, 2) }} руб</span>
      </loader-wrapper>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import LoaderWrapper from '@/components/Shared/LoaderWrapper'

import { FETCH_FIX_BLOCK_TTNS } from '@/store/actions/reports'

export default {
  name: 'FixedBlock',
  components: {
    LoaderWrapper,
  },
  props: {
    checkedResponses: {
      type: Array,
      default: () => [],
    },
    responses: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      netto: null,
      nettoFact: null,
    }
  },
  computed: {
    ...mapGetters({
      ttns: 'reports/getFixBlockTtns',
      loaded: 'reports/getLoadedTtns',
    }),
    params() {
      return this.ttns.reduce(
        (acc, cur) => {
          const responses = this.responses.find(
            response => response.id === cur.response_id,
          )
          const { price_from_storage_bidder, price_from_field_bidder } =
            responses || {}
          const price =
            this.type !== 'harvest'
              ? price_from_storage_bidder
              : price_from_field_bidder

          return {
            netto_ttn: Number(acc.netto_ttn + cur.netto_ttn),
            netto_fact: Number(acc.netto_fact + cur.netto_fact),
            amount: Number(acc.amount + cur.netto_fact * price),
          }
        },
        { netto_ttn: 0, netto_fact: 0, amount: 0 },
      )
    },
  },
  watch: {
    checkedResponses() {
      const ids = this.checkedResponses.map(r => r.id)

      this.$store.dispatch(`reports/${FETCH_FIX_BLOCK_TTNS}`, ids.join())
    },
  },
  methods: {
    thousandths(value, fixed) {
      return value.toFixed(fixed).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ')
    },
  },
}
</script>

<style lang="sass">
.fixed-block-wrap
  position: fixed
  left: 0
  right: 0
  bottom: 0
  margin: auto auto 10px auto
  width: 600px
  height: 20px
  background: white
  padding: 20px
  border: 1px solid #e7e7e7

  &--container
    & span
      display: inline-block
      margin-right: 20px
</style>
